module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// /home/readymade/apps/facelift_production/shared/~/core-js/modules/_fails.js
// module id = 21
// module chunks = 0